module.exports = __webpack_public_path__ + "475139604486ee564ec6f33db1a55161.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/user/public-user-accounts/confirm-remove/confirm-remove.html
// module id = 2467
// module chunks = 0